import request from '@/utils/request'

// 查询商机简要信息列表
export function querySimpleList(data) {
  return request({
    url: '/crmBusiness/querySimpleList',
    method: 'post',
    data: data
  })
}

// 分页查询商机简要信息列表
export function simpleListPage(data) {
  return request({
    url: '/crmBusiness/simpleListPage',
    method: 'post',
    data: data
  })
}

// 分页查询商机简要信息列表（带数据权限控制的）
export function simpleListPageAuth(data) {
  return request({
    url: '/crmBusiness/simpleListPageAuth',
    method: 'post',
    data: data
  })
}

// 分页查询客户志列表
export function queryListBusiness(data) {
  return request({
    url: '/crmBusiness/queryList',
    method: 'post',
    data: data
  })
}

// 校验商机名称
export function businessNameCheck(query) {
  return request({
    url: '/crmBusiness/businessNameCheck',
    method: 'get',
    params: query
  })
}

// 查询商机详情
export function queryBusinessDetail(query) {
  return request({
    url: '/crmBusiness/detail',
    method: 'get',
    params: query
  })
}

// 按客户或联系人查询商机列表
export function queryBusinessByTargetId(query) {
  return request({
    url: '/crmBusiness/queryByCustomerId',
    method: 'get',
    params: query
  })
}

// 查询商机关联联系人
export function queryBusinessContact(query) {
  return request({
    url: '/crmBusiness/queryBusinessContact',
    method: 'get',
    params: query
  })
}

// 查询商机竞争对手
export function queryBusinessCompetitor(query) {
  return request({
    url: '/crmBusiness/queryBusinessCompetitor',
    method: 'get',
    params: query
  })
}

// 查询商机方案
export function queryBusinessPlan(query) {
  return request({
    url: '/crmBusiness/queryBusinessPlan',
    method: 'get',
    params: query
  })
}


// 新增商机
export function addBusiness(data) {
  return request({
    url: '/crmBusiness/add',
    method: 'post',
    data: data
  })
}

// 更新商机
export function updateBusiness(data) {
  return request({
    url: '/crmBusiness/update',
    method: 'put',
    data: data
  })
}

// 根据关联id查询商机关联联系人
export function queryBusinessContactByRelateId(query) {
  return request({
    url: '/crmBusiness/queryBusinessContactByRelateId',
    method: 'get',
    params: query
  })
}

// 更新商机竞争对手
export function changeBusinessCompetitor(data) {
  return request({
    url: '/crmBusiness/changeCompetitor',
    method: 'post',
    data: data
  })
}

// 更新商机竞争方案
export function changeBusinessPlan(data) {
  return request({
    url: '/crmBusiness/changePlan',
    method: 'post',
    data: data
  })
}

// 根据关联id查询商机竞争对手
export function queryBusinessCompetitorByRelateId(query) {
  return request({
    url: '/crmBusiness/queryBusinessCompetitorByRelateId',
    method: 'get',
    params: query
  })
}

// 根据关联id查询商机方案
export function queryBusinessPlanByRelateId(query) {
  return request({
    url: '/crmBusiness/queryBusinessPlanByRelateId',
    method: 'get',
    params: query
  })
}

// 更新商机Swot分析
export function updateBusinessSwot(data) {
  return request({
    url: '/crmBusiness/changeSwot',
    method: 'post',
    data: data
  })
}

// 查询商机Swot分析
export function queryBusinessSwot(query) {
  return request({
    url: '/crmBusiness/queryBusinessSwot',
    method: 'get',
    params: query
  })
}

// 更新商机阶段
export function changeBusinessStage(data) {
  return request({
    url: '/crmBusiness/changeStage',
    method: 'post',
    data: data
  })
}

// 保存完成的阶段任务清单
export function saveCompleteStageItems(data) {
  return request({
    url: '/crmBusiness/saveCompleteStageItems',
    method: 'put',
    data: data
  })
}

// 更新商机关联联系人
export function changeBusinessContact(data) {
  return request({
    url: '/crmBusiness/changeContact',
    method: 'post',
    data: data
  })
}

// 更新商机关联联系人
export function updateBusinessStatus(data) {
  return request({
    url: '/crmBusiness/updateBusinessStatus',
    method: 'put',
    data: data
  })
}

// 查询商机团队成员列表
export function queryBusinessGroupMemberList(query) {
  return request({
    url: '/crmBusiness/queryBusinessGroupMemberList',
    method: 'get',
    params: query
  })
}

// 添加团队成员
export function addGroupMember(data) {
  return request({
    url: '/crmBusiness/addGroupMember',
    method: 'post',
    data: data
  })
}

// 移除团队成员
export function removeGroupMember(data) {
  return request({
    url: '/crmBusiness/removeGroupMember',
    method: 'put',
    data: data
  })
}

// 创建商机变更
export function createChangeApproval(data) {
  return request({
    url: '/crmBusiness/createChangeApproval',
    method: 'post',
    data: data
  })
}

// 查询商机阶段列表
export function businessStageList(param) {
  return request({
    url: '/crmBusiness/stageList',
    method: 'get',
    params: param
  })
}

// 恢复商机
export function recovery(data) {
  return request({
    url: '/crmBusiness/recovery',
    method: 'post',
    data: data
  })
}
